export default "__VITE_ASSET__Bo6xfKhJ__"